import { gql } from '@apollo/client';

export const CREATE_EMAIL_CONFIRMATION = gql`
  mutation CreateEmailConfirmation($email: String!) {
    createEmailConfirmation(email: $email) {
      entity
      errors {
        message
      }
    }
  }
`;

export const CONFIRM_EMAIL_CONFIRMATION = gql`
  mutation ConfirmEmailConfirmation($code: String!) {
    confirmEmailConfirmation(code: $code) {
      entity
      errors {
        message
      }
    }
  }
`;

export const DESTROY_USER = gql`
  mutation DestroyUser {
    destroyUser {
      entity
      errors {
        message
        path
      }
    }
  }
`;
